import { DITypes, EDateFormat } from "@/core/@types/types";
import type { IDateRange } from "@/core/composables/F360DateShortcuts/types";
import { F360UnitDate, type IF360Date } from "../date/F360Date";
import type { IF360DateUtils } from "../date/F360DateUtils";
import { inject, injectable } from "inversify";
import "reflect-metadata";

@injectable()
export default class DayJsUtils implements IF360DateUtils {
  @inject(DITypes.DATE)
  private libDate!: IF360Date;

  lastNinetyDays(): IDateRange {
    const endDate = this.libDate.subtract(this.today(), 90, F360UnitDate.Days);

    return {
      start: this.libDate.format(endDate, EDateFormat.dateParmFormat),
      end: this.libDate.format(this.today(), EDateFormat.dateParmFormat),
      formatedDate: {
        start: this.libDate.format(endDate, EDateFormat.day),
        end: this.libDate.format(this.today(), EDateFormat.day)
      }
    };
  }

  disableDay(date: Date, limit?: number | undefined): boolean {
    const today = new Date();
    //@kleber
    // eslint-disable-next-line @typescript-eslint/no-unused-vars, unused-imports/no-unused-vars
    const hasLimit = limit || 0;

    // const maxDays = this.libDate.subtract(today, hasLimit, F360UnitDate.Day);
    const isDayDisabledStarEnd = date > today;

    const disabledDay = isDayDisabledStarEnd;

    return disabledDay;
  }

  private today() {
    return this.libDate.now();
  }

  formatToDateRange(endDate: Date | string) {
    return {
      start: this.libDate.format(endDate, EDateFormat.dateParmFormat),
      end: this.libDate.format(this.today(), EDateFormat.dateParmFormat),
      formatedDate: {
        start: this.libDate.format(endDate, EDateFormat.day),
        end: this.libDate.format(this.today(), EDateFormat.day)
      }
    };
  }

  lastSevenDays(): IDateRange {
    const endDate = this.libDate.subtract(this.today(), 6, F360UnitDate.Days);

    return {
      start: this.libDate.format(endDate, EDateFormat.dateParmFormat),
      end: this.libDate.format(this.today(), EDateFormat.dateParmFormat),
      formatedDate: {
        start: this.libDate.format(endDate, EDateFormat.day),
        end: this.libDate.format(this.today(), EDateFormat.day)
      }
    };
  }

  lastMonth(): IDateRange {
    const firstDayOfLastMonth = this.libDate.startOf(
      this.libDate.subtract(this.today(), 1, F360UnitDate.Month),
      F360UnitDate.Month
    );

    const lastDayOfLastMonth = this.libDate.endOf(
      firstDayOfLastMonth,
      F360UnitDate.Month
    );

    return {
      start: this.libDate.format(
        firstDayOfLastMonth,
        EDateFormat.dateParmFormat
      ),
      end: this.libDate.format(lastDayOfLastMonth, EDateFormat.dateParmFormat),
      formatedDate: {
        start: this.libDate.format(firstDayOfLastMonth, EDateFormat.day),
        end: this.libDate.format(lastDayOfLastMonth, EDateFormat.day)
      }
    };
  }

  thisMonth(): IDateRange {
    const startDate = this.libDate.startOf(this.today(), F360UnitDate.Month);

    return {
      start: this.libDate.format(startDate, EDateFormat.dateParmFormat),
      end: this.libDate.format(this.today(), EDateFormat.dateParmFormat),
      formatedDate: {
        start: this.libDate.format(startDate, EDateFormat.day),
        end: this.libDate.format(this.today(), EDateFormat.day)
      }
    };
  }

  accumulated30Days(): IDateRange {
    const startDate = this.libDate.subtract(
      this.today(),
      30,
      F360UnitDate.Days
    );

    return {
      start: this.libDate.format(startDate, EDateFormat.dateParmFormat),
      end: this.libDate.format(this.today(), EDateFormat.dateParmFormat),
      formatedDate: {
        start: this.libDate.format(startDate, EDateFormat.day),
        end: this.libDate.format(this.today(), EDateFormat.day)
      }
    };
  }

  todayRange() {
    const startDate = this.libDate.now();

    return {
      start: this.libDate.format(startDate, EDateFormat.dateParmFormat),
      end: this.libDate.format(startDate, EDateFormat.dateParmFormat),
      formatedDate: {
        start: this.libDate.format(startDate, EDateFormat.day),
        end: this.libDate.format(startDate, EDateFormat.day)
      }
    };
  }

  yesterday() {
    const startDate = this.libDate.subtract(this.today(), 1, F360UnitDate.Day);

    return {
      start: this.libDate.format(startDate, EDateFormat.dateParmFormat),
      end: this.libDate.format(startDate, EDateFormat.dateParmFormat),
      formatedDate: {
        start: this.libDate.format(startDate, EDateFormat.day),
        end: this.libDate.format(startDate, EDateFormat.day)
      }
    };
  }

  nextThirtyDays(): IDateRange {
    const endDate = this.libDate.add(this.today(), 29, F360UnitDate.Day);

    return {
      start: this.libDate.format(this.today(), EDateFormat.dateParmFormat),
      end: this.libDate.format(endDate, EDateFormat.dateParmFormat),
      formatedDate: {
        start: this.libDate.format(this.today(), EDateFormat.day),
        end: this.libDate.format(endDate, EDateFormat.day)
      }
    };
  }

  lastweek(): IDateRange {
    const endDate = this.today();
    const startDate = this.libDate.subtract(endDate, 1, F360UnitDate.week);

    return {
      start: this.libDate.format(startDate, EDateFormat.dateParmFormat),
      end: this.libDate.format(endDate, EDateFormat.dateParmFormat),
      formatedDate: {
        start: this.libDate.format(startDate, EDateFormat.day),
        end: this.libDate.format(endDate, EDateFormat.day)
      }
    };
  }

  thisWeek(): IDateRange {
    const startDate = this.libDate.startOf(this.today(), F360UnitDate.week);
    const endDate = this.libDate.endOf(this.today(), F360UnitDate.week);

    return {
      start: this.libDate.format(startDate, EDateFormat.dateParmFormat),
      end: this.libDate.format(endDate, EDateFormat.dateParmFormat),
      formatedDate: {
        start: this.libDate.format(startDate, EDateFormat.day),
        end: this.libDate.format(endDate, EDateFormat.day)
      }
    };
  }

  lastYear(): IDateRange {
    const today = this.today();

    const firstDayOfYear = this.libDate.subtract(
      this.libDate.startOf(today, F360UnitDate.Year),
      1,
      F360UnitDate.Year
    );
    const lastDayOfLastYear = this.libDate.endOf(
      firstDayOfYear,
      F360UnitDate.Year
    );

    return {
      start: this.libDate.format(firstDayOfYear, EDateFormat.monthYear),
      end: this.libDate.format(lastDayOfLastYear, EDateFormat.monthYear),
      formatedDate: {
        start: this.libDate.format(firstDayOfYear, EDateFormat.monthYear),
        end: this.libDate.format(lastDayOfLastYear, EDateFormat.monthYear)
      }
    };
  }

  thisYear(): IDateRange {
    const startDate = this.libDate.startOf(this.today(), F360UnitDate.Year);
    const endDate = this.libDate.endOf(this.today(), F360UnitDate.Year);

    return {
      start: this.libDate.format(startDate, EDateFormat.monthYear),
      end: this.libDate.format(endDate, EDateFormat.monthYear),
      formatedDate: {
        start: this.libDate.format(startDate, EDateFormat.monthYear),
        end: this.libDate.format(endDate, EDateFormat.monthYear)
      }
    };
  }

  last12Months(): IDateRange {
    const endDate = this.today();
    const startDate = this.libDate.subtract(endDate, 12, F360UnitDate.Month);

    return {
      start: this.libDate.format(startDate, EDateFormat.monthYear),
      end: this.libDate.format(endDate, EDateFormat.monthYear),
      formatedDate: {
        start: this.libDate.format(startDate, EDateFormat.monthYear),
        end: this.libDate.format(endDate, EDateFormat.monthYear)
      }
    };
  }

  formatDate(date: string) {
    return this.libDate.format(date, EDateFormat.day);
  }
}
